import { render, staticRenderFns } from "./join.vue?vue&type=template&id=2ef480cc&scoped=true"
var script = {}
import style0 from "./join.vue?vue&type=style&index=0&id=2ef480cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef480cc",
  null
  
)

export default component.exports